import { z } from "zod";
import { idSchema, isoDateSchema } from "./common";
import { appointmentStatusSchema } from "./scheduling";

export const reportTypes = ["appointments", "finance", "invoices", "income-tax"] as const;
export const reportTypeSchema = z.enum(reportTypes);
export type ReportType = z.infer<typeof reportTypeSchema>;

export const reportQuerySchema = z.object({
  from: isoDateSchema.optional(),
  to: isoDateSchema.optional(),
  year: z.coerce.number().int().min(2000).max(2100).optional(),
  status: appointmentStatusSchema.optional(),
  locationId: idSchema.optional(),
});
export type ReportQuery = z.infer<typeof reportQuerySchema>;

/** Célula numérica é dinheiro; texto já vem pronto para exibir. */
export type ReportCell = string | number;

export interface ReportSection {
  title: string;
  columns: string[];
  rows: ReportCell[][];
  total?: ReportCell[];
}

export interface Report {
  type: ReportType;
  title: string;
  period: string;
  fileName: string;
  summary: { label: string; value: ReportCell }[];
  sections: ReportSection[];
  notes: string[];
}
